import { Roles } from "./constants"

export const handleWebSocketMessage = (message, options) => {
    switch (message.type) {
        case 'characters': {
            options.contexts.characters[message.scope](message.payload)
            break
        }
        case 'alliances': {
            options.contexts.data.save('alliances', message.payload)
            break
        }
        case 'events': {
            options.contexts.data.save(`${message.scope}Events`, message.payload)
            break
        }
        case 'lists': {
            options.contexts.data.save(`lists`, message.payload)
            break
        }
        case 'stellarSeasons': {
            message.payload.sort((s1, s2) => s2.name - s1.name)
            options.contexts.data.save(`stellarSeasons`, message.payload)
            break
        }
        default: {
            console.error('Unhandled message type', message)
        }
    }
}